<template>
  <div class="audio one-component-detail-admin">
    <div class="title-component-admin">
      <el-row type="flex" align="middle" justify="space-between">
        <span>Audio</span>
        <el-upload
          v-if="!audios.length"
          accept="audio/*"
          list-type="file"
          action
          :limit="1"
          :show-file-list="false"
          :http-request="uploadAudios"
        >
          <el-button
            type="primary"
            size="small"
            title="Chọn audio từ máy tính của bạn"
            :loading="loading"
          >
            Thêm
          </el-button>
        </el-upload>
        <div v-else>
          <el-button
            type="danger"
            size="small"
            :loading="loading"
            @click="deleteAudios"
          >
            Xóa
          </el-button>
        </div>
      </el-row>
    </div>
    <div v-if="!audios.length" v-loading="loading" class="empty p-3">
      Chưa có dữ liệu!
    </div>
    <el-row v-else class="p-3">
      <audio controls style="width: 100%">
        <source :src="audios[0].url" />
      </audio>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  listStorages,
  deleteStorages,
  createStorage
} from '@/services/storage'

export default {
  name: 'Audios',
  props: {
    data: Object,
    type: String
  },
  data() {
    return {
      loading: false,
      audios: []
    }
  },
  computed: {
    ...mapGetters(['language']),
    object_type() {
      if (['tour', 'post', 'artifact'].includes(this.type)) {
        return this.type
      }
      return 'place'
    }
  },
  beforeMount() {
    this.loadAudios()
  },
  methods: {
    loadAudios() {
      this.loading = true
      const params = {
        object_id: this.data.id,
        object_type: this.object_type,
        file_type: 'audio',
        order: 'ordered',
        locale: this.language
      }
      listStorages(params)
        .then((res) => {
          this.audios = res.result
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    uploadAudios(fileInfo) {
      const params = {
        file: fileInfo.file,
        objectId: this.data.id,
        objectType: this.object_type,
        fileType: 'audio',
        locale: this.language
      }
      this.loading = true
      createStorage(params)
        .then((res) => {
          this.audios = [res.data]
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$notify.error({
            title: 'Thông báo',
            message: 'Không thể upload audio: ' + fileInfo.file.name
          })
        })
    },

    deleteAudios() {
      this.$confirm('Bạn có chắc chắn muốn xóa không?', 'Xác nhận', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Đóng',
        type: 'warning'
      }).then(() => {
        const ids = this.audios.map((i) => i.id)
        this.loading = true
        deleteStorages({
          file_type: 'audio',
          object_type: this.object_type,
          ids: ids.join(',')
        })
          .then(() => {
            this.audios = []
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            this.$notify.error({
              title: 'Thông báo',
              message: 'Không thể xóa audio!'
            })
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
